export default __webpack_public_path__ + "static/media/icon_ihmiset_summary.109d5b7b.svg";